import DOMPurify from 'dompurify';

// Sanea HTML que proviene de fuentes no confiables (sobre todo respuestas del
// backend que luego se vuelcan en el DOM o en el editor TinyMCE). No dependemos
// del saneo interno de TinyMCE como única defensa: limpiamos antes de pasarle el
// contenido. Quitamos por completo cualquier manejador de eventos inline y los
// protocolos peligrosos en enlaces.
const sanitizeHtml = (dirty) => {
  if (!dirty || typeof dirty !== 'string') return '';
  return DOMPurify.sanitize(dirty, {
    // Neutraliza vectores típicos de XSS en cuerpos de email enriquecido.
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'formaction'],
  });
};

export default sanitizeHtml;
